(function(){
  function onReady(cb){
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  function init(){
    const isDesktop = window.matchMedia('(min-width: 990px)');

    // Toggle variants only on mobile/tablet
    function attachHandlers(){
      document.querySelectorAll('.product-card-wrapper').forEach(function(card){
        const toggleBtn = card.querySelector('.card__variants-toggle');
        const variants = card.querySelector('.card__variants');
        if(!toggleBtn || !variants) return;

        // Ensure bottom sheet containers exist once
        let sheet = document.querySelector('.card-variants-sheet');
        let backdrop = document.querySelector('.card-variants-sheet-backdrop');
        if(!sheet){
          sheet = document.createElement('div');
          sheet.className = 'card-variants-sheet';
          sheet.setAttribute('role','dialog');
          sheet.setAttribute('aria-modal','true');
          sheet.innerHTML = '<div class="card-variants-sheet__header"><strong class="h5" style="margin:0;">Options</strong><button class="card-variants-sheet__close" aria-label="Close">✕</button></div><div class="card-variants-sheet__body"></div>';
          document.body.appendChild(sheet);
        }
        if(!backdrop){
          backdrop = document.createElement('div');
          backdrop.className = 'card-variants-sheet-backdrop';
          document.body.appendChild(backdrop);
        }

        const body = sheet.querySelector('.card-variants-sheet__body');
        const closeBtn = sheet.querySelector('.card-variants-sheet__close');

        // Remove previous listener if any
        toggleBtn.__handler && toggleBtn.removeEventListener('click', toggleBtn.__handler);

        toggleBtn.__handler = function(e){
          // Only act on mobile/tablet
          if(isDesktop.matches) return;
          e.preventDefault();
          // Create a placeholder so we can restore position later
          let placeholder = card.querySelector('.card__variants-placeholder');
          if(!placeholder){
            placeholder = document.createElement('div');
            placeholder.className = 'card__variants-placeholder';
            variants.parentNode && variants.parentNode.insertBefore(placeholder, variants.nextSibling);
          }
          // Also create a placeholder for the variants JSON script
          let scriptPlaceholder = card.querySelector('.card__variants-script-placeholder');
          const variantScript = card.querySelector('script[id^="Variants-"]');
          if(!scriptPlaceholder && variantScript){
            scriptPlaceholder = document.createElement('div');
            scriptPlaceholder.className = 'card__variants-script-placeholder';
            variantScript.parentNode && variantScript.parentNode.insertBefore(scriptPlaceholder, variantScript.nextSibling);
          }
          // Move current card variants into the sheet
          body.innerHTML = '';
          body.appendChild(variants);
          // Mark active card so other modules (autoclick) can resolve the correct form
          sheet.__activeCard = card;
          // Move the related variants script into the sheet as well so dependent code can find it
          if(variantScript){ body.appendChild(variantScript); }
          sheet.classList.add('is-open');
          backdrop.classList.add('is-open');
          toggleBtn.setAttribute('aria-expanded','true');
          // Focus management
          setTimeout(function(){ closeBtn && closeBtn.focus(); }, 50);
        };
        toggleBtn.addEventListener('click', toggleBtn.__handler);

        function closeSheet(){
          if(!sheet.classList.contains('is-open')) return;
          sheet.classList.remove('is-open');
          backdrop.classList.remove('is-open');
          toggleBtn.setAttribute('aria-expanded','false');
          // Return variants back under the card at the placeholder
          const placeholder = card.querySelector('.card__variants-placeholder');
          if(placeholder){
            placeholder.parentNode && placeholder.parentNode.insertBefore(variants, placeholder);
            placeholder.remove();
          } else {
            // Fallback: append to card content bottom
            const content = card.querySelector('.card__content');
            content && content.appendChild(variants);
          }
          // Return the variants script to its original position
          const scriptPlaceholderBack = card.querySelector('.card__variants-script-placeholder');
          const movedScript = body.querySelector('script[id^="Variants-"]');
          if(scriptPlaceholderBack && movedScript){
            scriptPlaceholderBack.parentNode && scriptPlaceholderBack.parentNode.insertBefore(movedScript, scriptPlaceholderBack);
            scriptPlaceholderBack.remove();
          }
          sheet.__activeCard = null;
        }

        closeBtn && closeBtn.addEventListener('click', closeSheet);
        backdrop && backdrop.addEventListener('click', closeSheet);
        window.addEventListener('keydown', function(ev){ if(ev.key === 'Escape') closeSheet(); });
      });
    }

    attachHandlers();

    // Re-attach on resize or section load or collection re-render
    window.addEventListener('resize', attachHandlers);
    document.addEventListener('shopify:section:load', attachHandlers);
    document.addEventListener('collection:rendered', attachHandlers);
  }

  onReady(init);
})();


document.addEventListener('DOMContentLoaded', function(){
  document.body.addEventListener('click', function(e){
    var target = e.target;
    
    // Check if the clicked element or its parent is the toggle button
    var toggleBtn = target.closest('.card__variants-toggle');
    if (!toggleBtn) return;
    
    // Find the product card wrapper
    var cardWrapper = toggleBtn.closest('.product-card-wrapper');
    if (!cardWrapper) return;
    
    // Find the container within this card
    var container = cardWrapper.querySelector('.card-variants-info-container');
    if (!container) return;
    
    // Check if it's currently open BEFORE removing classes
    var isCurrentlyOpen = container.classList.contains('is-open');
    
    // Close all containers
    var allContainers = document.querySelectorAll('.card-variants-info-container');
    allContainers.forEach(function(cont){
      cont.classList.remove('is-open');
    });
    
    // If it wasn't open, open it now (toggle behavior)
    // This way: first click opens it, second click closes it
    if (!isCurrentlyOpen) {
      container.classList.add('is-open');
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Handle mobile variants toggle and close buttons
  document.body.addEventListener('click', function(e) {
    var target = e.target;
    var toggleBtn = target.closest('.mobile-variants-toggle');
    var closeButton = target.closest('.mobile-variants-close-button');
    
    // Handle toggle button
    if (toggleBtn) {
      var cardWrapper = toggleBtn.closest('.product-card-wrapper');
      if (!cardWrapper) return;
      
      var container = cardWrapper.querySelector('.card-variants-info-container');
      if (!container) return;
      
      // Check if it's currently open BEFORE removing classes
      var isCurrentlyOpen = container.classList.contains('is-open');
      
      // Close all containers
      var allContainers = document.querySelectorAll('.card-variants-info-container');
      allContainers.forEach(function(cont) {
        cont.classList.remove('is-open');
      });
      
      // If it wasn't open, open it now (toggle behavior)
      if (!isCurrentlyOpen) {
        container.classList.add('is-open');
      }
      return;
    }
    
    // Handle close button
    if (closeButton) {
      var cardWrapper = closeButton.closest('.product-card-wrapper');
      if (!cardWrapper) return;
      
      var container = cardWrapper.querySelector('.card-variants-info-container');
      if (container) {
        container.classList.remove('is-open');
      }
    }
  });
});